import { useMemo, useRef } from 'react';

type InputOptions = {
  multiple?: boolean;
  max?: number;
  accept?: string;
};

export const useHiddenUpload = (options: InputOptions = {}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const openFileInput = () => inputRef.current?.click();

  const inputProps = useMemo(
    () => ({
      ref: inputRef,
      multiple: options.multiple,
      max: options.max,
      accept: options.accept || '.jpg,.jpeg,.png,.webp,.heic',
      style: { display: 'none' },
      type: 'file'
    }),
    []
  );

  return { openFileInput, inputProps };
};
